/** CRONOGRAMA-MSP (09/10/2026): o tom do aviso (a porta opcional do `LinhaRecolhivel` e do `<Aviso>`). */
export type TomDoAviso = 'neutro' | 'atencao' | 'perigo';
export const CLASSES_DO_TOM: Record<TomDoAviso, string> = {
  neutro: 'border-line bg-paper-warm/60 dark:border-line-dark dark:bg-paper-dark-warm/60',
  atencao: 'border-[rgba(176,127,45,0.35)] bg-[rgba(176,127,45,0.08)]',
  perigo: 'border-red-soft bg-red-soft/50 dark:border-red-soft-dark dark:bg-red-soft-dark/40',
};
